import { Component, OnInit, inject } from '@angular/core';
import {AbstractControl, AsyncValidatorFn, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { map, Observable, tap } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';
import { CustomValidators } from 'src/app/_helpers/customValidators';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    standalone: true,
    imports: [MatFormFieldModule,CommonModule,ReactiveFormsModule]
})
export class RegisterComponent implements OnInit {
  private authService = inject(AuthService);
  private _accountService = inject(AccountService);
  private router = inject(Router);


  errorMessage: string = null;
  registerForm: UntypedFormGroup;
  submitted: boolean = false;
  error: boolean = false;



  ngOnInit(): void {

    this.registerForm = new UntypedFormGroup({
      'firstName': new UntypedFormControl(null, CustomValidators.required),
      'surname': new UntypedFormControl(null, CustomValidators.required),
      'email': new UntypedFormControl(null, {
        validators: [CustomValidators.required, CustomValidators.email],
        asyncValidators: this.forbiddenEmails,
        updateOn: 'blur'
      }),
      'passwordData' : new UntypedFormGroup({
        'password': new UntypedFormControl(null, [CustomValidators.passwordHasUpper, CustomValidators.minLength(8), CustomValidators.passwordHasSpecial, CustomValidators.required]),
        'rptPassword': new UntypedFormControl(null,CustomValidators.required)
      },{validators: [CustomValidators.passwordsMatch]})
  })

}

  onSubmit(){
    this.submitted = true;
    this.authService.register({
      firstName: this.registerForm.get('firstName').value as string,
      surname: this.registerForm.get('surname').value as string,
      email: this.registerForm.get('email').value as string,
      password: this.registerForm.get('passwordData.password').value as string
    }).subscribe(
      {
        next: (data) => {

        },
        error: (error) => {
          this.errorMessage = error.message;
          this.error = true;
        }
      }
    );
  }

  forbiddenEmails: AsyncValidatorFn = (control: AbstractControl):  Promise<any> | Observable<any> =>
  {
    return this._accountService.checkEmail(control.value).pipe
    (
      map((exists: any) => {
        return exists.result ? {emailExists: true}: null
      }
        )
    );
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.registerForm.get(fieldName);
    return field && field.invalid && field.touched;
  }

  showError() {
    console.log(this.registerForm.get('passwordData.password').errors)
  }
}
